import { createFileRoute } from "@tanstack/react-router";
import { kennelNotesRoute, KennelNotesPage } from "@/features/provider-home";

export const Route = createFileRoute("/kennel/_dashboard/notes")({
    ssr: kennelNotesRoute.ssr,
    head: kennelNotesRoute.head,
    component: KennelNotesPage,
});
